import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AssessmentProvider } from "./context/AssessmentContext";
import Welcome from "./pages/Welcome";
import ClientInfo from "./pages/ClientInfo";
import Questionnaire from "./pages/Questionnaire";
import Results from "./pages/Results";
import ScopeOfWork from "./pages/ScopeOfWork";

function App() {
  return (
    <div className="App">
      <AssessmentProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Welcome />} />
            <Route path="/client" element={<ClientInfo />} />
            <Route path="/questionnaire" element={<Questionnaire />} />
            <Route path="/results" element={<Results />} />
            <Route path="/scope" element={<ScopeOfWork />} />
          </Routes>
        </BrowserRouter>
      </AssessmentProvider>
    </div>
  );
}

export default App;
